import Drilldown from 'components/drilldown/Layout'
import integrationStore from 'modules/report/stores/integrationReport'
import TextTruncated from '@Components/TextTruncated';
import ObjectModal from '@Components/modals/ObjectModal';

import { formatters } from 'components/hierarchical-report/utils'

export default class LossesDrilldown extends Drilldown {
  store = integrationStore
  collection = 'Integrations'
  report = 'integrations'

  metrics = {
    rulesSuccessful: { label: 'Rules Accepted', field: 'rules_result', value: true },
    prepingSuccessful: { label: 'Preping Accepted', field: 'preping_success', value: true },
    prepingRejected: { label: 'Preping Rejected', field: 'preping_success', value: false },
    successCalls: { label: 'Success Calls', field: 'success', value: true },
    failedCalls: { label: 'Failed Calls', field: 'fail', value: true },
    total: { label: 'Total' },
  }

  fields = {
    default: ['integrationId', 'integrationType', 'vendor', 'sessionId', 'userId', 'success'],
    options: [
      { group: 'Integration', value: "integrationId", label: "Id" },
      { group: 'Integration', value: "vendor", label: "Vendor" },
      { group: 'Integration', value: "integrationType", label: "Type" },
      { group: 'Integration', value: "trigger", label: "Trigger" },
      { group: 'Integration', value: "siteId", label: "Site Id" },
      { group: 'Integration', value: "rulesResult", label: "Rules Result" },
      { group: 'Integration', value: "active", label: "Active" },
      { group: 'Integration', value: "success", label: "Success" },
      { group: 'Integration', value: "fail", label: "Failed calls" },
      { group: 'Integration', value: "deliveryDate", label: "Delivery Date" },
      { group: 'Integration', value: "latency", label: "Latency" },
      { group: 'Integration', value: "statusCode", label: "Status" },
      { group: 'Integration', value: "twynePreping", label: "Twyne Preping" },
      { group: 'Integration', value: "prepingSuccess", label: "Preping Success" },
      { group: 'Integration', value: "feedbackMessage", label: "Feedback Message" },
      { group: 'HTTP Details', value: "httpData__request", label: "HTTP Request Details" },
      { group: 'HTTP Details', value: "httpData__response", label: "HTTP Response Details" },
      { group: 'HTTP Details', value: "httpData__request__body", label: "HTTP Request Body" },
      { group: 'HTTP Details', value: "httpData__response__body", label: "HTTP Response Body" },
      { group: 'HTTP Details', value: "httpData__request__url", label: "HTTP Request URL" },
      { group: 'HTTP Details', value: "httpData__request__method", label: "HTTP Request Method" },
      { group: 'HTTP Details', value: "httpData__request__params", label: "HTTP Request Params" },
      { group: 'HTTP Details', value: "httpData", label: "HTTP Full Details" },
      { group: 'Integration', value: "integrationDetails", label: "Integration Details" },

      { group: 'User', value: 'userId', label: 'Id' },
      { group: 'User', value: 'userCreatedAt', label: 'Created At' },
      { group: 'User', value: 'userUpdatedAt', label: 'Updated At' },
      { group: 'User', value: 'userFirstName', label: 'First Name' },
      { group: 'User', value: 'userLastName', label: 'Last Name' },
      { group: 'User', value: 'userEmail', label: 'Email' },
      { group: 'User', value: 'userAddress1', label: 'Address 1' },
      { group: 'User', value: 'userAddress2', label: 'Address 2' },
      { group: 'User', value: 'userCity', label: 'City' },
      { group: 'User', value: 'userState', label: 'State' },
      { group: 'User', value: 'userZip', label: 'Zip' },
      { group: 'User', value: 'userCountry', label: 'Country' },
      { group: 'User', value: 'userPhone', label: 'Phone' },
      { group: 'User', value: 'userDob', label: 'Date of Birth' },
      { group: 'User', value: 'userAge', label: 'Age' },
      { group: 'User', value: 'userGender', label: 'Gender' },
      { group: 'User', value: 'userUnsubscribed', label: 'Unsubscribed' },
      { group: 'User', value: 'userValidated', label: 'Validated' },

      { group: "Session", value: "sessionId" , label: "Id" },
      { group: "Session", value: "sessionCreatedAt" , label: "Created At" },
      { group: "Session", value: "sessionUpdatedAt" , label: "Updated At" },
      { group: "Session", value: "sessionOrganizationId" , label: "Organization Id" },
      { group: "Session", value: "sessionAllocationId" , label: "Allocation Id" },
      { group: "Session", value: "sessionFormId" , label: "Form Id" },
      { group: "Session", value: "sessionOfferId" , label: "Offer Id" },
      { group: "Session", value: "sessionPublisherId" , label: "Publisher Id" },
      { group: "Session", value: "sessionPathId" , label: "Path Id" },
      { group: "Session", value: "sessionPostId" , label: "Post Id" },
      { group: "Session", value: "sessionPostTargetId" , label: "Post Target Id" },
      { group: "Session", value: "sessionPostVersionId" , label: "Post Version Id" },
      { group: "Session", value: "sessionSid1" , label: "Sub1" },
      { group: "Session", value: "sessionSid2" , label: "Sub2" },
      { group: "Session", value: "sessionSid3" , label: "Sub3" },
      { group: "Session", value: "sessionSlotPosition" , label: "Slot Position" },
      { group: "Session", value: "sessionPayoutType" , label: "Payout Type" },
      { group: "Session", value: "sessionConversionType" , label: "Conversion Type" },
      { group: "Session", value: "sessionConverted" , label: "Converted" },
      { group: "Session", value: "sessionTcpaConsent" , label: "TCPA Consent" },
      { group: "Session", value: "sessionRegistrationConsent" , label: "Registration Consent" },
      { group: "Session", value: "sessionRecordingConsent" , label: "Recording Consent" },
      { group: "Session", value: "sessionCost" , label: "Cost" },
      { group: "Session", value: "sessionBrowserAgent" , label: "Browser Agent" },
      { group: "Session", value: "sessionExternalId" , label: "External Id" },
      { group: "Session", value: "sessionCampaignId" , label: "Campaign Id" },
      { group: "Session", value: "sessionReferrer" , label: "Referrer" },
      { group: "Session", value: "sessionOriginalUrl" , label: "Url" },
      { group: "Session", value: "sessionIpAddress" , label: "Ip" },
      { group: "Session", value: "sessionDevice" , label: "Device" },
      { group: "Session", value: "sessionOS" , label: "OS" },
      { group: "Session", value: "sessionBrowser" , label: "Browser" },
      { group: "Session", value: "sessionTrustedFormCert" , label: "Trusted Form" },
      { group: "Session", value: "sessionLeadidCert" , label: "Lead Id" },
      { group: "Session", value: "sessionRegistrationCompleted" , label: "Registration Completed" },
      { group: "Session", value: "sessionRegistrationTotalStep" , label: "Registration Total Step" },
      { group: "Session", value: "sessionRegistrationStep" , label: "Registration Step" },
      { group: "Session", value: "SessionDuplicated" , label: "Session Duplicated" },
      { group: "Session", value: "sessionSkipRegistration" , label: "Skip Registration" },
      { group: "Session", value: "sessionEmailVerification" , label: "Email Verification" },
      { group: "Session", value: "sessionAddressVerification" , label: "Address Verification" },
      { group: "Session", value: "sessionBotVerification" , label: "Bot Verification" },
      { group: "Session", value: "sessionFraudVerification" , label: "Fraud Verification" },
      { group: "Session", value: "sessionFraudScore" , label: "Fraud Score" },
      { group: "Session", value: "sessionHook" , label: "Hook" },
      { group: "Session", value: "sessionOptout" , label: "Optout" },
      { group: "Session", value: "sessionPhoneVerification" , label: "Phone Verification" },
      { group: "Session", value: "sessionPostalVerification" , label: "Postal Verification" },
      { group: "Session", value: "sessionIpCity" , label: "Ip City" },
      { group: "Session", value: "sessionIpState" , label: "Ip State" },
      { group: "Session", value: "sessionIpZip" , label: "Ip Zip" },
      { group: "Session", value: "sessionRevenue" , label: "Revenue" },
    ],
    fieldsFormatters: {
      httpData: cell => {
        if (!cell) return null;

        const request = { ...cell.request, request_body: cell.request.body }
        const response = { ...cell.response, response_body: cell.response.body }

        delete request.body
        delete response.body

        const data = Object.entries(request).concat(Object.entries(response))

        return <ObjectModal title="HTTP DATA" data={data} id="http" labelButton="more details" />
      },
      httpData__request__url: textTruncatedFormatter('url-request'),
      httpData__request__params: objectModalFormatter('params-request', 'HTTP Request Params'),
      httpData__request__body: objectModalFormatter('body-request', 'HTTP Request Body'),
      httpData__response__body: objectModalFormatter('http-data-request', 'HTTP Response Body'),
      httpData__request: objectModalFormatter('http-data-request', "HTTP Request Details"),
      httpData__response: objectModalFormatter('http-data-response', "HTTP Response Details"),
      integrationDetails: objectModalFormatter('integrtion-details', "Integration Details"),
    }
  }
}

const objectModalFormatter = (id, title, label = 'details') => (cell, _, idx) => {
  if (!cell) return null;

  if (typeof cell === 'string') {
    try {
      cell = JSON.parse(cell)
    } catch (error) {
      return cell
    }
  }
  const data = Object.entries(cell);
  return <ObjectModal data={data} title={title} labelButton={label} id={`${id}-${idx}`} />
}

const textTruncatedFormatter = id => (cell, _, idx) => {
  if (!cell) return null;

  return <TextTruncated maxLength={30} id={`${id}-${idx}`}>
    {cell}
  </TextTruncated>
}
